exports.f = Object.getOwnPropertySymbols;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_object-gops.js
 ** module id = 494
 ** module chunks = 1
 **/